import { NetworkPlanService } from "@/app/plans/network/services/network.plan.service"


const initPlanData = {
  type: 'network',
  name: null,
  device_id: null,

  camp_leave: null,
  camp_back: null,
  work_areas: [],
  camp_id:null,
  start_date:'',
  end_date:''
}


const initialState = () => {
  return {
    loading: false,
    errors: {},
    data: Object.assign({}, initPlanData)
  }
}


const state = initialState()

const mutations = {

  RESET_STORE_DATA(state) {
    Object.assign(state, { ...initialState() })
  },

  REQUEST_SEND(state) {

    Object.assign(state, {
      loading: true,
      errors: {}
    })
  },

  REQUEST_FINISHED(state) {
    Object.assign(state, {
      loading: false,
    })
  },


  SET_PLAN_DATA(state, data) {
     console.log(data)

    Object.assign(state.data, {
      ...data,
      work_areas: data.data.work_areas,
      start_date:data.data.start_date,
      end_date:data.data.end_date

    })

    delete state.data.data

  },

  

  REQUEST_SUCCESS(state) {
    Object.assign(state, {
      data: Object.assign({}, initPlanData),
      errors: {},
      loading: false
    })
  },

  REQUEST_ERROR(state, error) {
    Object.assign(state, {
      errors: error,
      loading: false
    })
  },



}


const actions = {

  createPlan(context) {
    return new Promise((resolve, reject) => {
      context.commit('REQUEST_SEND')
      NetworkPlanService.createPlan(context.state.data).then(res => {
        context.commit('REQUEST_SUCCESS')
        resolve(res)
      }).catch(reason => {
        if (reason.status === 422) {
          reject(reason.data.message)
          context.commit('REQUEST_ERROR', reason.data.errors)
        }
      })
    })
  },


  updatePlan(context, id) {
    return new Promise((resolve, reject) => {
      context.commit('REQUEST_SEND')
      NetworkPlanService.updatePlan(id, context.state.data).then(res => {
        context.commit('REQUEST_FINISHED')
        resolve(res)
      }).catch(reason => {
        if (reason.status === 422) {
          reject(reason.data.message)
          context.commit('REQUEST_ERROR', reason.data.errors)
        }
      })
    })
  },

  getPlan(context, id) {
    return new Promise((resolve, reject) => {
      context.commit('REQUEST_SEND')
      NetworkPlanService.getPlanById(id).then(res => {

        context.commit('REQUEST_SUCCESS')
        context.commit('SET_PLAN_DATA', res)
        resolve(res)
      }).catch(reason => {
        if (reason.status === 422) {
          reject(reason.data.message)
          context.commit('REQUEST_ERROR', reason.data.errors)
        }
      })
    })
  },

  deletePlan(context, id, PlanType) {
    return new Promise((resolve, reject) => {
      NetworkPlanService.deletePlan(id, PlanType).then(res => resolve(res))
        .catch(reason => reject(reason))
    })
  },

}




export default {
  namespaced: true,
  state,
  mutations,
  actions
};
